import {ErrorHandler} from '@angular/core';

export class StringUtils {

    /**
     * Formats.
     * @param aText
     * @param aArgs
     */
    static format(aText : string,  aArgs : any[]) {
        let result = aText;
        let i = 0;
        for (let arg of aArgs) {
            let strToReplace = "{" + i++ + "}";
            result = result.replace(strToReplace, (arg || ''));
        }
        return result;
    }

    /**
     * Normalizes.
     * @param aStr
     */
    static normalizeStringEmpty(aStr: String): String {
        return (aStr == null ? "" : aStr);
    }

    /**
     * Splits menu name
     * @param aFullName
     * @return Splitted
     */
    static splitMenuName(aFullName: string): string[] {
        let pFullName = aFullName.trim();
        let pEnd = pFullName.indexOf(",");
        if (pEnd >= 0) {
            return [pFullName.substring(0, pEnd + 1).trim(), pFullName.substring(pEnd + 1).trim()];
        }
        return [pFullName, null];
    }

    /**
     * Truncates.
     *
     * @param aMsg
     * @param aLength
     * @return
     */
    static truncateEllipsis(aMsg : string, aLength : number) : string {
        if (!aMsg) {
            return null;
        }
        return aMsg.length > aLength ? aMsg.substring(0, aLength - 1) + ".." : aMsg;
    }

    static maskAsterisk(src:string){
        if (src && src.length>4) return new Array(src.length-4).fill('*').join('') + src.substring(src.length-4);
        return src;
    }
}